export default __webpack_public_path__ + "static/media/f-and-b.b2b8a4ae.webp";